<template>
  <form ref="form">
    <v-layout align-space-between justify-space-between row wrap>
      <v-flex xs12 sm7 md7 lg7 xl7 pr-5>
        <v-text-field
          v-model="searchProduct"
          prepend-icon="search"
          v-validate="'required|min:3'"
          :error-messages="errors.collect('searchProduct')"
          data-vv-name="searchProduct"
          data-vv-as="Search Product"
          label="Search Product"
        ></v-text-field>
      </v-flex>
      <v-flex xs5>
        <v-btn type="submit" color="primary mx-0" @click="submit">
          show products
        </v-btn>
        <v-btn flat @click="clear">clear</v-btn>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import { mapState } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    searchProduct: ""
  }),
  computed: mapState("search", ["searchString", "loading"]),
  methods: {
    submit(event) {
      event.preventDefault();
      this.$validator.validateAll().then(valid => {
        if (!this.loading && valid) {
          this.$emit("submitSearchQuery", this.searchProduct);
        }
      });
    },
    clear() {
      this.searchProduct = "";
      this.$refs.form.reset();
      this.$validator.reset();
      this.$emit("clearSearch");
    }
  },
  mounted() {
    this.searchProduct = this.searchString;
  }
};
</script>
